"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dictionary = {
    arguments: {
        entity: "Invalid arguments provided to @Entity decorator. See: https://www.devnet.io/libs/TypeGraph/ for valid arguments.",
        field: "Invalid arguments provided to @Field decorator. See: https://www.devnet.io/libs/TypeGraph/ for valid arguments."
    },
    duplicate: {
        variable: "Duplicate variable name declared with different type information. Variables added with the same name must have the same type."
    },
    invalid: {
        query: "Invalid QueryType provided to generateQuery. See: https://www.devnet.io/libs/TypeGraph/ for valid types.",
        mutation: "Invalid MutationType provided to generateMutation. See: https://www.devnet.io/libs/TypeGraph/ for valid types.",
        class: "Invalid class supplied. Is it decorated with @Entity and at least one @Field?"
    },
    warning: {
        operation: "No Operation decorator metadata found on class. Defaulting to Query."
    }
};
exports.default = dictionary;
//# sourceMappingURL=dictionary.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/util/dictionary.js
// module id = 1448
// module chunks = 0